import { RatingLevelsDefinitions } from './rating-levels-definitions';

export class RatingLevels {
  public static hazardTypes: Array<string> = ['A', 'B', 'C'];
  public static hazardTypesAmazon: Array<string> = ['D', 'E'];

  public static A: Array<string> = RatingLevelsDefinitions.A.levels;
  public static B: Array<string> = RatingLevelsDefinitions.B.levels;
  public static C: Array<string> = RatingLevelsDefinitions.C.levels;
  public static D: Array<string> = RatingLevelsDefinitions.D.levels;
  public static E: Array<string> = RatingLevelsDefinitions.E.levels;
  public static merged: Array<string> = RatingLevelsDefinitions.merged.levels;
  public static mergedAmazon: Array<string> = RatingLevelsDefinitions.mergedAmazon.levels;
}
